// ============================================================
//	ナルミヤキャラクターズ × studio CLIP
// ============================================================

// ------------------------------------------------
//	スクロールアニメーション（.anim → .active）
// ------------------------------------------------
const scrollAnim = () => {
	const items = document.querySelectorAll('.anim');
	if (!items.length) return;

	const check = () => {
		const th = window.innerHeight * 0.85;
		items.forEach((el) => {
			if (el.classList.contains('active')) return;
			const r = el.getBoundingClientRect();
			if (r.top < th && r.bottom > 0) el.classList.add('active');
		});
	};

	check();
	window.addEventListener('load', check, { once: true });
	window.addEventListener('scroll', check, { passive: true });
	window.addEventListener('resize', check);
};

// ------------------------------------------------
//	オープニング（loading → KV）
//	固定 1.5秒で必ず抜ける。
//	`?skip`（?skip / ?skip=1 / 他パラメータとの併用も可）で
//	ローディングと KV〜intro の順送りを丸ごと飛ばし、最初から完成状態で表示する
// ------------------------------------------------
const OPENING_MS = 5000;

const isSkip = () => new URLSearchParams(location.search).has('skip');

const opening = () => {
	const op = document.getElementById('nrop');
	const nr = document.querySelector('.nr');
	if (!nr) return;

	// スキップ: ローディングを消し、順送りアニメを走らせずに完成状態にする
	if (isSkip()) {
		if (op) op.remove();
		nr.classList.add('is-skip');
		return;
	}

	const start = () => {
		nr.classList.add('is-op');
	};

	if (!op) {
		start();
		return;
	}

	window.setTimeout(() => {
		op.classList.add('is-out');
		start();
		op.addEventListener('animationend', () => op.remove(), { once: true });
	}, OPENING_MS);
};

window.addEventListener('DOMContentLoaded', () => {
	opening();
	scrollAnim();
});
